/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from '../../index-892d8eee.js';
import { extend } from '../extend/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/**
 *  Common
 */
var ERROR_REQUEST_ABORT = {
  code: 0,
  message: 'Request Abort'
};
var ERROR_REQUEST_TIMEOUT = {
  code: 1,
  message: 'Request timeout'
};
var ERROR_REQUEST_JSONP = function ERROR_REQUEST_JSONP(url) {
  return {
    code: 1,
    message: "JSONP error : request " + url + " error"
  };
};

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends$2({}, rest, _ext[baseName] || {});
};

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};
var JSONP_SIGN = '__uni_jsonp_handler_sign__';

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function stringifyQS(qs) {
  if (!qs) {
    return '';
  }

  var str = [];

  for (var key in qs) {
    if (qs[key]) {
      str.push(key + "=" + encodeURIComponent(String(qs[key])));
    }
  }

  return str.join('&');
}
function applyParamToURL(param, url) {
  if (!param) {
    return url;
  }

  return "" + url + (url.indexOf('?') === -1 ? '?' : '&') + stringifyQS(param);
}
function object2json(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    return obj || '';
  }
}
function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}
function normalizeHeaders(obj) {
  if (!isObject(obj)) {
    return obj;
  }

  var keyList = ['Accept', 'Content-Type'];
  keyList.forEach(function (key) {
    for (var headerKey in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, headerKey)) {
        if (headerKey.toUpperCase() === key.toUpperCase() && headerKey !== key) {
          obj[key] = obj[headerKey];
          delete obj[headerKey];
        }
      }
    }
  });
  return obj;
}
var validateStatus = function validateStatus(status) {
  return status >= 200 && status < 300 || status === 304;
};
function checkIsApplyDataToURL(headers) {
  if (!headers || !headers['Content-Type']) {
    return false;
  }

  return String(headers['Content-Type']).toLowerCase().indexOf('application/x-www-form-urlencoded') > -1;
}
var EMPTY_OBJECT = {};
function isPlainObject(obj) {
  return EMPTY_OBJECT.toString.call(obj) === '[object Object]';
}
function styleOptions(options, containerName) {
  var _options$method;

  var DEFAULT_TIMEOUT = 20000;
  var DEFAULT_REQUEST_OPTIONS = {
    url: '',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET',
    jsonpCallbackProp: 'callback',
    jsonpCallback: "__uni_jsonp_handler_" + new Date().getTime(),
    timeout: DEFAULT_TIMEOUT,
    dataType: 'json'
  };
  var isJsonp = (options == null ? void 0 : (_options$method = options.method) == null ? void 0 : _options$method.toUpperCase()) === 'JSONP';

  if (isJsonp && containerName === CONTAINER_NAME.WEB) {
    window[JSONP_SIGN] = typeof window[JSONP_SIGN] !== 'undefined' ? window[JSONP_SIGN] + 1 : 0;
    DEFAULT_REQUEST_OPTIONS.jsonpCallback = DEFAULT_REQUEST_OPTIONS.jsonpCallback + "_" + window[JSONP_SIGN];
  }

  var jsonpCallback = options.jsonpCallback || DEFAULT_REQUEST_OPTIONS.jsonpCallback;

  var adapterResponse = function adapterResponse(res) {
    var _res$errMsg;

    if (res.errMsg && (res == null ? void 0 : (_res$errMsg = res.errMsg) == null ? void 0 : _res$errMsg.indexOf('request:fail')) !== -1 || res.error) {
      return _extends$1({}, res, {
        error: res.error || res.status || res.statusCode,
        errorMessage: res.errorMessage || res.errMsg || '',
        status: res.statusCode || res.status,
        headers: res.header || res.headers || {}
      });
    }

    var afterRes = _extends$1({}, res, {
      errorMessage: res.errorMessage || res.errMsg || '',
      status: res.statusCode || res.status,
      headers: res.header || res.headers || {}
    });

    if (isJsonp && containerName !== CONTAINER_NAME.WEB) {
      try {
        var _reg$exec;

        var reg = new RegExp(jsonpCallback + "\\(([\\s\\S]*)\\);?$", 'gm');
        var content = (_reg$exec = reg.exec(res == null ? void 0 : res.data)) == null ? void 0 : _reg$exec[1];
        var data = content ? JSON.parse(content) : '';
        return _extends$1({}, afterRes, {
          data: data
        });
      } catch (e) {
        return {
          error: 14,
          data: res,
          errorMessage: 'JSONP 解码失败'
        };
      }
    }

    return afterRes;
  };

  var afterOptions = _extends$1({}, DEFAULT_REQUEST_OPTIONS, options, {
    method: (options.method || 'GET').toUpperCase(),
    headers: _extends$1({}, DEFAULT_REQUEST_OPTIONS.headers, normalizeHeaders(options.headers || {})),
    success: function success(res) {
      var _validateStatus = options.validateStatus || validateStatus;

      var _res = adapterResponse(res);

      if (!_validateStatus(_res.status)) {
        options.fail && options.fail(_res);
      } else {
        options.success && options.success(_res);
      }
    },
    fail: function fail(res) {
      options.fail && options.fail(adapterResponse(res));
    },
    complete: function complete(res) {
      options.complete && options.complete(adapterResponse(res));
    }
  });

  if (isJsonp) {
    var _extends2;

    afterOptions = _extends$1({}, afterOptions, {
      method: 'GET',
      isJsonp: isJsonp,
      dataType: 'text',
      data: _extends$1({}, options.data, (_extends2 = {}, _extends2[options.jsonpCallbackProp || DEFAULT_REQUEST_OPTIONS.jsonpCallbackProp] = jsonpCallback, _extends2))
    });
  }

  return afterOptions;
}
function normalize(api, containerName) {
  return function (options) {
    var afterOptions = styleOptions(styleIn(options, containerName), containerName);
    return api(afterOptions);
  };
}

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function requestXHR(options) {
  options.headers = _extends({
    Accept: 'application/json, text/plain, */*'
  }, options.headers);

  var _jsonpCallbackProp$js = _extends({
    jsonpCallbackProp: 'callback',
    jsonpCallback: "__uni_jsonp_handler_" + new Date().getTime(),
    withCredentials: true,
    method: 'GET',
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300 || status === 304;
    }
  }, options),
      validateStatus = _jsonpCallbackProp$js.validateStatus,
      url = _jsonpCallbackProp$js.url,
      method = _jsonpCallbackProp$js.method,
      isJsonp = _jsonpCallbackProp$js.isJsonp,
      withCredentials = _jsonpCallbackProp$js.withCredentials,
      headers = _jsonpCallbackProp$js.headers,
      data = _jsonpCallbackProp$js.data,
      timeout = _jsonpCallbackProp$js.timeout,
      jsonpCallback = _jsonpCallbackProp$js.jsonpCallback,
      dataType = _jsonpCallbackProp$js.dataType,
      success = _jsonpCallbackProp$js.success,
      fail = _jsonpCallbackProp$js.fail,
      complete = _jsonpCallbackProp$js.complete;

  var timer;

  function noop() {}

  if (isJsonp) {
    var script;
    var target = document.getElementsByTagName('script')[0] || document.head;

    var _clean = function _clean() {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }

      window[jsonpCallback] = noop;
      timer && clearTimeout(timer);
    };

    if (timeout) {
      timer = setTimeout(function () {
        _clean();

        fail && fail(ERROR_REQUEST_TIMEOUT);
        complete && complete(ERROR_REQUEST_TIMEOUT);
      }, timeout);
    }

    window[jsonpCallback] = function (data) {
      _clean();

      success && success({
        data: data,
        status: 200,
        headers: {}
      });
      complete && complete({
        data: data,
        status: 200,
        headers: {}
      });
    };

    var scriptUrl = "" + applyParamToURL(data, url);
    script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    target.parentNode.insertBefore(script, target);

    script.onerror = function () {
      fail && fail(ERROR_REQUEST_JSONP);

      _clean();
    };

    return {
      abort: function abort() {}
    };
  }

  var requestData;
  var xhr = new XMLHttpRequest();

  var clean = function clean() {
    clearTimeout(timer);
  };

  timer = window.setTimeout(function () {
    clean();
    fail && fail(ERROR_REQUEST_TIMEOUT);
    complete && complete(ERROR_REQUEST_TIMEOUT); // reject(ERROR_REQUEST_TIMEOUT);

    xhr.abort();
  }, timeout);

  xhr.onreadystatechange = function () {
    if (!xhr || xhr.readyState !== 4) {
      return;
    }

    clean();

    if (!validateStatus(xhr.status)) {
      // TODO Detailed error message
      fail && fail({
        code: ERROR_REQUEST_ABORT.code,
        message: "" + JSON.stringify({
          status: xhr.status
        })
      });
      complete && complete({
        code: ERROR_REQUEST_ABORT.code,
        message: "" + JSON.stringify({
          status: xhr.status
        })
      });
      return;
    }

    var headers = xhr.getAllResponseHeaders();
    var arr = headers.trim().split(/[\r\n]+/);
    var headerMap = {};
    arr.forEach(function (line) {
      var parts = line.split(': ');
      var header = parts.shift();
      var value = parts.join(': ');
      headerMap[header] = value;
    });
    success && success({
      data: xhr.response,
      status: xhr.status,
      headers: headerMap
    });
    complete && complete({
      data: xhr.response,
      status: xhr.status,
      headers: headerMap
    });
  };

  xhr.responseType = dataType || '';

  if (method === 'GET' || checkIsApplyDataToURL(headers)) {
    xhr.open(method, applyParamToURL(data, url), true);
  } else {
    xhr.open(method, url, true);
  }

  xhr.withCredentials = withCredentials;

  if (headers) {
    for (var key in headers || []) {
      if (Object.prototype.hasOwnProperty.call(headers, key)) {
        xhr.setRequestHeader(key, String(headers[key]));
      }
    }
  }

  if (method === 'GET') {
    requestData = null;
  } else {
    requestData = data;
  }

  if (isObject(requestData) && isPlainObject(requestData)) {
    requestData = object2json(requestData);
  }

  xhr.send(requestData);
  return {
    abort: function abort() {}
  };
}

var webModule = normalize(requestXHR, CONTAINER_NAME.WEB);

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

function request$5(options) {
  var url = options.url,
      method = options.method,
      data = options.data,
      dataType = options.dataType,
      headers = options.headers,
      timeout = options.timeout,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var httpRequest = isDingdingMiniapp ? dd.httpRequest : my.request;
  var _data = data;

  if (isDingdingMiniapp && method === 'POST' && headers['Content-Type'] === 'application/json' && typeof data !== 'string') {
    _data = JSON.stringify(data);
  }

  return httpRequest({
    url: url,
    headers: headers,
    method: method,
    data: _data,
    timeout: timeout,
    dataType: dataType,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}

var aliMiniAppModule = normalize(request$5, CONTAINER_NAME.ALIPAY);

function request$4(options) {
  var url = options.url,
      method = options.method,
      data = options.data,
      dataType = options.dataType,
      headers = options.headers,
      timeout = options.timeout,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  return wx.request({
    url: url,
    header: headers,
    method: method,
    data: data,
    timeout: timeout,
    dataType: dataType,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}

var weChatModule = normalize(request$4, CONTAINER_NAME.WECHAT);

function request$3(options) {
  var url = options.url,
      method = options.method,
      data = options.data,
      dataType = options.dataType,
      headers = options.headers,
      timeout = options.timeout,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  return tt.request({
    url: url,
    header: headers,
    method: method,
    data: data,
    timeout: timeout,
    dataType: dataType,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}

var bytedanceModule = normalize(request$3, CONTAINER_NAME.BYTE);

function request$2(options) {
  var url = options.url,
      method = options.method,
      data = options.data,
      dataType = options.dataType,
      headers = options.headers,
      timeout = options.timeout,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  return swan.request({
    url: url,
    header: headers,
    method: method,
    data: data,
    timeout: timeout,
    dataType: dataType,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}

var baiDuModule = normalize(request$2, CONTAINER_NAME.WECHAT);

function request$1(options) {
  var url = options.url,
      method = options.method,
      data = options.data,
      dataType = options.dataType,
      headers = options.headers,
      timeout = options.timeout,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  return ks.request({
    url: url,
    header: headers,
    method: method,
    data: data,
    timeout: timeout,
    dataType: dataType,
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}

var kuaiShouModule = normalize(request$1, CONTAINER_NAME.WECHAT);

var uniRequest = (function (options) {
  if (isWeb) {
    return webModule(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule(options);
  } else if (isMiniApp) {
    return aliMiniAppModule(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule(options);
  } else {
    throw new Error('Uni API：request暂不支持');
  }
});

var apiConfig = {
    // XMLHttpRequest: https://github.com/raxjs/universal-api/blob/master/src/packages/network/request/src/web/index.ts
    web: uniRequest,
    // my.request: https://github.com/raxjs/universal-api/blob/master/src/packages/network/request/src/ali-miniapp/index.ts
    mini: uniRequest,
};
/**
 * 用于发起网络请求
 * https://universal-api.js.org/packages/network/request
 */
var request = extend(apiConfig);

export { request };
